import { render } from "./TheHeader.vue?vue&type=template&id=fb6ce392&scoped=true"
import script from "./TheHeader.vue?vue&type=script&lang=js"
export * from "./TheHeader.vue?vue&type=script&lang=js"

import "./TheHeader.vue?vue&type=style&index=0&id=fb6ce392&scoped=true&lang=css"

import exportComponent from "/home/armenium/56-free-school-street/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb6ce392"]])

export default __exports__